export default __webpack_public_path__ + "static/media/lp-new-backfit-pricing-desktop.f6fad24a.jpg";